import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Checkbox from "@material-ui/core/Checkbox";
import Layout from "../layouts/Layout";
import SingleDealPayment from "../components/SingleDealPayment";
import SingleDealDispatch from "../components/SingleDealDispatch";
import Snackbar from "@material-ui/core/Snackbar";
import { primaryShade1, primaryShade4, grey, white } from "../styles/color";
import Moment from "moment";

const styles = {
  root: {
    color: primaryShade1,
    "&$checked": {
      color: primaryShade1
    }
  },
  checked: {}
};
class Deals extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      singleDeal: "",
      isLoading: true,
      value: 0,
      checkedA: false,
      checkedB: false,
      checkedC: false,
      open: false,
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ]
    };
  }
  componentWillMount() {
    this.initializeData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.initializeData(nextProps);
  }
  initializeData = whichProps => {
    let tempSelectedDeal = whichProps.deals.find(ele => {
      return ele.id === this.props.match.params.dealId;
    });
    this.setState({
      singleDeal: tempSelectedDeal,
      isLoading: false
    });
    this.setState({
      checkedA: tempSelectedDeal.isDealPaymentComplete,
      checkedB: tempSelectedDeal.isDealDeliveryComplete,
      checkedC: !tempSelectedDeal.activeStatus
    });
  };
  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleCheckBox = (name, type) => event => {
    this.setState({ [name]: event.target.checked });
    this.props.handlePaymentDeliveryCheckbox(
      type,
      event.target.checked,
      this.props.match.params.dealId
    );
  };
  handleCopleteDealCheckBox = name => event => {
    this.setState({ [name]: event.target.checked, open: true });
    this.props.updateDealStatus(
      event.target.checked,
      this.props.match.params.dealId
    );
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  getDateValue = dateValue => {
    let recievedDateType = typeof dateValue;
    let currentDate =
      recievedDateType === "object"
        ? dateValue.toDate()
        : Moment(dateValue).toDate();
    let date = currentDate.getDate();
    let month = this.state.months[currentDate.getMonth()];
    let year = currentDate
      .getYear()
      .toString()
      .substr(-2);
    let dateMonthYear = date + " " + month + " " + year;
    return dateMonthYear;
  };
  render() {
    const {
      value,
      singleDeal,
      isLoading,
      checkedA,
      checkedB,
      checkedC
    } = this.state;
    const { payments, dispatches } = this.props;
    return isLoading ? (
      "wait"
    ) : (
      <Layout
        position="static"
        bottomNavigation={true}
        appBar
        appBarTitle={`${singleDeal.sellerName}-${singleDeal.buyerName}`}
        appBarLeftIcon={true}
        appBarRightIcon={true}
        selectedValue={0}
      >
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              marginTop: "55px",
              backgroundColor: primaryShade1,
              color: white
            }}
          >
            <div
              id="1"
              style={{
                display: "flex",
                justifyContent: "space-between",
                textAlign: "center",
                alignItems: "center",
                width: "100%"
              }}
            >
              <div style={{ width: "25%", textAlign: "center" }}>
                {singleDeal.quantity} Ton
              </div>
              <hr style={{ height: "20px" }} />
              <div style={{ width: "25%", textAlign: "center" }}>
                {singleDeal.typeOfRate}
              </div>
              <hr style={{ height: "20px" }} />
              <div style={{ width: "25%", textAlign: "center" }}>
                <span>&#8377; {singleDeal.rate}/Ton</span>
              </div>
              <hr style={{ height: "20px" }} />
              <div style={{ width: "25%", textAlign: "center" }}>
                <span>{this.getDateValue(singleDeal.date)}</span>
              </div>
            </div>
            <div
              id="2"
              style={{
                display: "flex",
                justifyContent: "space-between",
                textAlign: "center",
                alignItems: "center",
                backgroundColor: white,
                color: grey,
                width: "100%"
              }}
            >
              <div
                style={{
                  display: "flex",
                  fontSize: "0.7em",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "33%"
                }}
              >
                <Checkbox
                  checked={checkedA}
                  onChange={this.handleCheckBox("checkedA", "paymentComplete")}
                  value="checkedA"
                  color="primary"
                />
                <span>COMPLETE PAYMENT</span>
              </div>
              <hr style={{ height: "20px" }} />
              <div
                style={{
                  display: "flex",
                  fontSize: "0.7em",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "34%"
                }}
              >
                <Checkbox
                  checked={checkedB}
                  onChange={this.handleCheckBox("checkedB", "deliveryComplete")}
                  value="checkedB"
                  color="primary"
                />
                <span>COMPLETE DELIVERY</span>
              </div>
              <hr style={{ height: "20px" }} />
              <div
                style={{
                  display: "flex",
                  fontSize: "0.7em",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "33%"
                }}
              >
                <Checkbox
                  checked={checkedC}
                  onChange={this.handleCopleteDealCheckBox("checkedC")}
                  value="checkedC"
                  color="primary"
                />
                <span>CLOSE DEAL</span>
              </div>
              <Snackbar
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center"
                }}
                open={
                  this.state.checkedC === true && this.state.open === true
                    ? true
                    : false
                }
                onClose={this.handleClose}
                autoHideDuration={2200}
                ContentProps={{
                  "aria-describedby": "message-id"
                }}
                message={
                  <span id="message-id">
                    {singleDeal.sellerName}-{singleDeal.buyerName} deal is
                    closed
                  </span>
                }
              />
            </div>
          </div>
          <Tabs
            TabIndicatorProps={{ style: { backgroundColor: primaryShade4 } }}
            value={value}
            onChange={this.handleChange}
            fullWidth
            style={{
              backgroundColor: primaryShade1,
              margin: "10px",
              color: white
            }}
          >
            <Tab
              label="PAYMENT"
              style={{
                backgroundColor: value === 0 ? primaryShade4 : primaryShade1
              }}
            />
            <hr />
            <Tab
              label="DISPATCH"
              style={{
                backgroundColor: value === 2 ? primaryShade4 : primaryShade1
              }}
            />
          </Tabs>
          {value === 0 && (
            <SingleDealPayment
              singleDeal={singleDeal}
              payments={payments}
              isPaymentComplete={checkedA}
            />
          )}
          {value === 2 && (
            <SingleDealDispatch
              singleDeal={singleDeal}
              dispatches={dispatches}
              isDeliveryComplete={checkedB}
            />
          )}
        </div>
      </Layout>
    );
  }
}
Deals.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withRouter(withStyles(styles)(Deals));
